import { useParams, useNavigate } from 'react-router';
import { Typography, Alert, Box, CircularProgress } from '@mui/material';
import { AppLayout } from '@/components/layout/AppLayout';
import { AccountHeader, AccountTabsSimple } from '@/components/app/account';
import { useAuth } from '@/hooks/useAuth';
import { useAccount } from '@/lib/query/hooks';

export function AccountDetailPage() {
  const params = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const accountId = params.id as string;

  // アカウント詳細を取得
  const { data: account, isLoading: loading, error } = useAccount(accountId);

  const handleBack = () => {
    navigate('/');
  };

  // サーバーサイドレンダリング時は何も表示しない
  if (!isAuthenticated) {
    return null;
  }

  // 認証ローディング中
  if (authLoading) {
    return (
      <AppLayout>
        <Box sx={{ width: '90%', mx: 'auto', px: 2 }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>認証状態を確認中...</Typography>
        </Box>
      </AppLayout>
    );
  }

  // データローディング中
  if (loading) {
    return (
      <AppLayout>
        <Box sx={{ width: '90%', mx: 'auto', px: 2 }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>読み込み中...</Typography>
        </Box>
      </AppLayout>
    );
  }

  // エラー状態
  if (error) {
    return (
      <AppLayout>
        <Box sx={{ width: '90%', mx: 'auto', px: 2 }}>
          <Alert severity="error">
            {error instanceof Error ? error.message : 'アカウント詳細の読み込みに失敗しました。'}
          </Alert>
        </Box>
      </AppLayout>
    );
  }

  // アカウントが見つからない場合
  if (!account) {
    return (
      <AppLayout>
        <Box sx={{ width: '90%', mx: 'auto', px: 2 }}>
          <Alert severity="warning">アカウントが見つかりませんでした。</Alert>
        </Box>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <Box sx={{ width: '90%', mx: 'auto', px: 2 }}>
        <AccountHeader account={account} onBack={handleBack} />
        <AccountTabsSimple account={account} />
      </Box>
    </AppLayout>
  );
}
